import { render, staticRenderFns } from "./InfinitePolygons.vue?vue&type=template&id=ce22f362&scoped=true&"
import script from "./InfinitePolygons.vue?vue&type=script&lang=js&"
export * from "./InfinitePolygons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce22f362",
  null
  
)

export default component.exports